import { render, staticRenderFns } from "./MarketplacePatentsFilteredViewAll.vue?vue&type=template&id=f7b2a692&scoped=true"
import script from "./MarketplacePatentsFilteredViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplacePatentsFilteredViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePatentsFilteredViewAll.vue?vue&type=style&index=0&id=f7b2a692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b2a692",
  null
  
)

export default component.exports